import { render } from "./LogbookRulesModal.vue?vue&type=template&id=00e08806&scoped=true"
import script from "./LogbookRulesModal.vue?vue&type=script&lang=js"
export * from "./LogbookRulesModal.vue?vue&type=script&lang=js"

import "./LogbookRulesModal.vue?vue&type=style&index=0&id=00e08806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e08806"]])

export default __exports__